import { render, staticRenderFns } from "./SM-Lead-Status-Selectbox.vue?vue&type=template&id=0bdae757"
import script from "./SM-Lead-Status-Selectbox.vue?vue&type=script&lang=js"
export * from "./SM-Lead-Status-Selectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports